import React from "react";
import { PieceInfoGroupProps } from "./pieceInfoGroup";

export default function MovementsPieceInfoGroup(props: PieceInfoGroupProps) {
    if(props.piece.movements == undefined || props.piece.movements.length === 0) return <></>;
    return <>
        <h4>Movements</h4>
        {props.piece.movements.map((movement, index) => (
            <p key={index}>{movement}</p>
        ))}
    </>;
}